// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/element-variables.scss
// module id = KASW
// module chunks = 1